<template>
    <b-row>
        <b-col cols="12" class="mb-4">
            <b-card no-body border-variant="transparent" bg-variant="transparent" class="glass">
                <div style="height:50px;" v-show="programSeasonPostulantLoading">
                    <pulse-loader
                        :color="'#5e72e4'"
                        :margin="'10px'"
                        :size="20"
                        style="position:absolute;top:50%;left:50%;transform:translate(-50%,-50%)"/>
                </div>

                <b-card-body
                    v-show="!programSeasonPostulantLoading"
                    class="py-2 text-uppercase text-center text-white"
                    style="font-weight: bolder"
                    body-border-variant="transparent"
                    body-bg-variant="transparent"
                >
                    {{ programSeasonPostulant.attributes.postulant_full_name }} - {{ programSeasonPostulant.attributes.user_document_number }} - {{ programSeasonPostulant.attributes.program }} - {{ programSeasonPostulant.attributes.season }}
                </b-card-body>
            </b-card>
        </b-col>

        <b-col cols="12" class="mb-4">
            <div class="intranet-nav-content apk-nav-tabs">
                <intranet-nav-content-link-exact :link="{ name: 'Detalles', path: { name: 'employee-postulants-details-CA' } }"/>
                <intranet-nav-content-link :link="{ name: 'Pagos', path: { name: 'employee-postulants-payments-vouchers-CA' } }"/>
                <intranet-nav-content-link :link="{ name: 'Entrevistas', path: { name: 'employee-postulants-interviews-CA' } }"/>
                <intranet-nav-content-link :link="{ name: 'Contrato', path: { name: 'employee-postulants-contracts-CA' } }"/>
            </div>
        </b-col>

        <b-col>
            <slide-y-down-transition :duration="350" origin="center top" mode="out-in">
                <router-view></router-view>
            </slide-y-down-transition>
        </b-col>
    </b-row>

</template>

<script>
import { getProgramSeasonPostulant } from '@/api/ProgramSeasonPostulant/ProgramSeasonPostulant'
import IntranetNavContentLink from '@/layout/NavContent/IntranetNavContentLink';
import IntranetNavContentLinkExact from '@/layout/NavContent/IntranetNavContentLinkExact';
import { SlideYDownTransition  } from 'vue2-transitions';
//import { PulseLoader } from '@saeris/vue-spinners'

export default {
    name: 'Postulant',
    components: { 
        IntranetNavContentLink,
        IntranetNavContentLinkExact,
        SlideYDownTransition,
        // PulseLoader
    },
    data: () => ({
        programSeasonPostulant: {
            attributes: {}
        },
        programSeasonPostulantLoading: false
    }),
    created () {
        this.getData()
    },
    methods: {
        getData () {
            this.programSeasonPostulantLoading = true

            getProgramSeasonPostulant(this.$route.params.IdProgramSeasonPostulant)
                .then(({data}) => {
                    this.programSeasonPostulant = data.data
                })
                .catch(err => {
                    console.log('getProgramSeasonPostulant err', err);
                })
                .finally(() => {
                    this.programSeasonPostulantLoading = false
                    console.log('request getProgramSeasonPostulant end');
                })
        }
    }
};
</script>

<style scoped>
.glass {
    background-color: rgba(255, 255, 255, .3) !important;
    box-shadow: 0 3px 6px rgba(0, 0, 0, 0.1) !important;
    backdrop-filter: blur(5px) !important;
    color: white !important;
    border:1px solid rgba(255, 255, 255, 0.9) !important;
    overflow: hidden;
}
.intranet-nav-content {
    display: flex;
    align-items: center;
    overflow-x:auto;
    white-space:nowrap;
}
</style>